import { render, staticRenderFns } from "./TabSlider.vue?vue&type=template&id=0f21e1fe"
import script from "./TabSlider.vue?vue&type=script&lang=js"
export * from "./TabSlider.vue?vue&type=script&lang=js"
import style0 from "./TabSlider.vue?vue&type=style&index=0&id=0f21e1fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports